import Constants from "expo-constants";
import { Platform } from "react-native";

import { log } from "@/logger";

import { presentAndroidForegroundPush } from "./presentAndroidForegroundPush";
import { refreshQueriesFromPush } from "./refreshQueriesFromPush";

/**
 * When push is enabled, RNFB is autolinked on Android and may receive FCM in the
 * foreground before expo-notifications. Subscribe so the bell badge refreshes
 * and a local heads-up is shown. Returns an unsubscribe function.
 */
export async function subscribeAndroidForegroundPush(): Promise<() => void> {
    if (Platform.OS !== "android") {
        return () => undefined;
    }

    if (!Constants.expoConfig?.extra?.pushEnabled) {
        return () => undefined;
    }

    try {
        const { getMessaging, onMessage } = await import(
            "@react-native-firebase/messaging"
        );
        const unsubscribe = onMessage(getMessaging(), (remoteMessage) => {
            log.debug("Android FCM onMessage", remoteMessage.data);
            const data = remoteMessage.data as
                | Record<string, unknown>
                | undefined;
            refreshQueriesFromPush(data);
            void presentAndroidForegroundPush({
                title: remoteMessage.notification?.title,
                body: remoteMessage.notification?.body,
                data,
            }).catch((error) => {
                log.warn(
                    "Failed to present Android foreground notification",
                    error,
                );
            });
        });
        return unsubscribe;
    } catch (error) {
        log.warn("Failed to subscribe to Android FCM onMessage", error);
        return () => undefined;
    }
}
